import { ForwardedRef, forwardRef, useEffect, useState } from 'react';
import { IParsedImage } from '@components/typescript';
import styles from '@features/cms/components/collections/ProductPremiumBlock/components/ProductPremiumImage/ProductPremiumImage.styles';
import VideoPlayer from '@components/Video/VideoPlayer';
import { IVideoWithThumbnail } from '@features/cms/typescript';
import ResponsiveImage from '@components/ResponsiveImage/ResponsiveImage';
import GetImageAlt from '@utils/getImageAlt';
type PropsType = {
  image: string | IParsedImage;
  video: IVideoWithThumbnail;
  height?: number;
  fullScreen?: boolean;
  alignLeft?: boolean;
};
interface ISlot {
  image: string | IParsedImage | null;
  video: IVideoWithThumbnail | null;
}
const ProductPremiumImage = forwardRef(({
  image,
  video,
  height = 0,
  fullScreen = false,
  alignLeft = false
}: PropsType, ref: ForwardedRef<HTMLElement>) => {
  const [firstImageSlot, setFirstImageSlot] = useState<ISlot | null>(null);
  const [secondImageSlot, setSecondImageSlot] = useState<ISlot | null>(null);
  const [isFirstSlot, setIsFirstSlot] = useState(false);
  const loadNewSlot = () => {
    const setImageSlot = isFirstSlot ? setSecondImageSlot : setFirstImageSlot;
    const obj = {
      image,
      video
    };
    setImageSlot(obj);
    setIsFirstSlot(!isFirstSlot);
  };
  useEffect(() => {
    loadNewSlot();
  }, [image]);
  const getSlotImageAlt = (imageObject: ISlot) => {
    if (typeof imageObject.image === 'string') return '';
    if (imageObject.image?.image) return GetImageAlt(imageObject.image.image);
    return '';
  };
  const renderImage = (isActive: boolean, imageObject: ISlot) => {
    const slotAlt = getSlotImageAlt(imageObject);
    if (imageObject.video?.link && imageObject.video.link.length > 0) {
      return <div sx={styles.videoContainer(isActive)}>
            <VideoPlayer video={imageObject.video.link} playVideo poster={imageObject.video.thumbnail || undefined} loop ref={ref as ForwardedRef<HTMLDivElement>} fitVideo alt={slotAlt} />
          </div>;
    }
    if (typeof imageObject.image === 'string' && imageObject.image || typeof imageObject.image === 'object' && imageObject.image?.image?.desktop) {
      const alt = slotAlt;
      return <div sx={styles.image(isActive)} ref={ref as ForwardedRef<HTMLDivElement>}>
            <ResponsiveImage image={typeof imageObject.image === 'string' ? imageObject.image : imageObject.image.image} blur={typeof imageObject.image !== 'string' ? imageObject.image?.blur : undefined} alt={alt} objectFit="contain" sx={{
          objectPosition: ['center bottom', 'center bottom', 'center bottom', 'center bottom', 'center']
        }} />
          </div>;
    }
    return <></>;
  };
  return <div sx={styles.imageContainer(height ?? 0, fullScreen ?? false, alignLeft ?? false)}>
        {firstImageSlot && renderImage(isFirstSlot, firstImageSlot)}
        {secondImageSlot && renderImage(!isFirstSlot, secondImageSlot)}
      </div>;
});
ProductPremiumImage.displayName = 'ProductPremiumImage';
export default ProductPremiumImage;